import { CommonModule } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild, Input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from "@angular/router";
import saveAs from "file-saver";
import { MarkdownModule } from "ngx-markdown";
import { Driver, driver } from 'driver.js';
import { AccordionModule } from 'primeng/accordion';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';
import { DialogComponent } from '../../../../../../@core/components/ui/dialog/dialog.component';
import { DialogService } from '../../../../../../@core/services/dialog.service';
import { DeleteConfirmationComponent } from '../../../../../../@core/components/ui/delete-confirmation/delete-confirmation.component';
import { ButtonComponent } from "../../../../../../@core/components/ui/button/button.component";
import { CardModule } from "primeng/card";
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from "primeng/select";
import { ToggleComponent } from "../../../../../../@core/components/ui/toggle/toggle.component";
import { PopoverModule } from 'primeng/popover';
import { PanelModule } from "primeng/panel";
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DrawerModule } from "primeng/drawer";
import { SkeletonModule } from "primeng/skeleton";
import { SplitterModule } from "primeng/splitter";
import { TableModule } from "primeng/table";
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from "primeng/tooltip";
import { COMMENTS_TYPE, TRACEABILITY_LEVEL, USER_ROLE } from "../../../../../../@core/models/enums";
import { IAttachment, IUser } from "../../../../../../@core/models/model";
import { AuthenticationService } from "../../../../../../@core/services/authentication.service";
import { ProductWalkThroughService } from "../../../../../../@core/services/product-walk-through.service";
import { CLIENT_EVENTS, SOCKET_EVENTS, SocketService } from "../../../../../../@core/services/socket.service";
import { ToastService } from "../../../../../../@core/services/toast.service";
import { CollapsiblePanelService } from "../../../../../../@shared/components/collapsible-panel/collapsible-panel.service";
import { DataTableComponent } from "../../../../../../@shared/components/data-table/data-table.component";
import { DocumentPreviewComponent } from "../../../../../../@shared/components/document-preview/document-preview.component";
import { DocumentsErrorLoaderComponent } from "../../../../../../@shared/components/documents-error-loader/documents-error-loader.component";
import { DocumentsLoaderComponent } from "../../../../../../@shared/components/documents-loader/documents-loader.component";
import { DocumentsStackLoaderComponent } from "../../../../../../@shared/components/documents-stack-loader/documents-stack-loader.component";
import { PdfViewerComponent } from "../../../../../../@shared/components/pdf-viewer/pdf-viewer.component";
import { SearchBarComponent } from "../../../../../../@shared/components/search-bar/search-bar.component";
import { DynamicComponentRenderer } from "../../../../../../@shared/directives/dynamic-component-renderer.directive";
import { FormatTextPipe } from "../../../../../../@shared/pipes/formated-text.pipe";
import { TruncatePipe } from "../../../../../../@shared/pipes/truncate.pipe";
import { UserNameDisplayComponent } from "../../../../../../@shared/components/user-name-display/user-name-display.component";
import { FilterPipe } from "../../../../../../pipes/filter.pipe";
import { DOCUMENT_MODEL, EMBEDDINGS_GENERATION_STATUS, IContract, IDocumentCompare } from "../../../../../models/contract-management.model";
import { COMPARE_DOCUMENT_STATUS, ICompareKpi, ICompareMatrix, IKpi, KPI_DATA_TYPE } from "../../../../../models/settings.model";
import { AUDIT_MODULE, AuditLogService, IAuditLog } from "../../../../../services/audit-log.service";
import { ChatSource } from "../../../../chat/chat.component";
import { CompareService } from "../compare.service";
import { InputTextModule } from "primeng/inputtext";
import { Textarea } from "primeng/textarea";
import { PopoverComponent } from "../../../../../../@core/components/ui/popover/popover.component";
import { ITabPanelConfig, TabsPanelsComponent } from "../../../../../../@core/components/ui/tabs-panels/tabs-panels.component";
import { CompareDocumentsTabComponent } from "./tabs/documents-tab.component";
import { CompareReportsTabComponent } from "./tabs/reports-tab.component";
import { CompareAuditLogTabComponent } from "./tabs/audit-log-tab.component";
import { CompareCommentsTabWrapperComponent } from "./tabs/comments-tab-wrapper.component";
import { SelectComponent } from "../../../../../../@core/components/ui/select";
import { PRODUCT_WALKTHROUGH_TYPE } from "../../../../../models/contract-management.model";
import { ChatBubbleComponent } from "src/app/@shared/components/chat-bubble/chat-bubble.component";
import { ChatSidebarService } from "src/app/features/chat/services/chat-sidebar.service";
import { CompareChatTabComponent } from "src/app/features/chat/components/compare-chat-tab/compare-chat-tab.component";
import { ContractTopBarComponent, ContractTopBarView } from "../../contract-top-bar/contract-top-bar.component";
import { IconSourceEnum } from "../../../../../../@core/components/ui/icon/icon.component";
import { CustomMenuItem } from "../../../../../../@core/components/ui/menu/menu.component";
import { CaptureIssueComponent } from "../../../../../../@shared/components/capture-issue/capture-issue.component";
import { CreditsOverviewComponent } from "../../../../../../features/credits/components/credits-overview/credits-overview.component";
import { SupportTicketFormComponent } from "../../../../../../@shared/components/support-ticket-form/support-ticket-form.component";
import { SupportTicketDialogService } from "../../../../../../@shared/services/support-ticket-dialog.service";
import { TextCasePipe } from "../../../../../../@shared/pipes/textCase.pipe";
import { CaptureResult } from "../../../../../../@core/models/model";
import { SVG, TOP_BAR_SVG } from "../../../../../../common/svgs";

type downloadMode = 'preview' | 'download' | 'open';

enum FullscreenDialogType {
    COMPLIANCE_MATRIX = 'complianceMatrix',
    CHART = 'chart',
    FULL_REPORT = 'fullReport'
}

export enum REPORT_VIEW {
    MATRIX = 'MATRIX',
    CHART = 'CHART',
    FULL_REPORT = 'FULL_REPORT'
}

export enum KPI_MODE {
    ADD = 'Add',
    EDIT = 'Edit',
    RETRY = 'Retry',
    RESUME = 'Resume'
}


enum COMPARE_SOCKETS_EVENTS {
    COMPARE_LEVEL_STATUS = 'COMPARE_LEVEL_STATUS',
    COMPARE_KPI_DATA = 'COMPARE_KPI_DATA', // STATUS AND RESPONSE
    COMPARE_KPI_MESSAGES = 'COMPARE_KPI_MESSAGES',
    COMPARE_KPI_TODOS = 'COMPARE_KPI_TODOS',
}

export enum DOWNLOAD_AUDIT_LOGS_TYPE {
    EXCEL = 'EXCEL',
    PDF = 'PDF',
}

export interface IKpiStatusItem {
    kpiId: string;
    status: COMPARE_DOCUMENT_STATUS;
    /** Propagated from ThreadMetadata.pauseReason; 'credits_exhausted' triggers the credits UI. */
    pauseReason?: string | null;
}

export interface ICompareSocketsResponse {
    event: COMPARE_SOCKETS_EVENTS
    compareId: string

    status: COMPARE_DOCUMENT_STATUS
    /** Compare-level pause reason forwarded from the backend (e.g. 'credits_exhausted'). */
    pauseReason?: string | null,

    kpiId: string | null,
    kpiStatus: COMPARE_DOCUMENT_STATUS | null
    kpiData: any,
    kpiMessages: any,
    kpiTodos: any,
    kpiStatuses?: IKpiStatusItem[],
}

export interface IDocumentType {
    _id: string,
    name: string,
    linkedDocTypeName: string,
    highlightCount: number,
    attachment: IAttachment,
    embeddingsStatus: EMBEDDINGS_GENERATION_STATUS

    mainDocument: boolean,
    consideredForComparison: boolean,
    consideredWithLinkedDocs: boolean,

    pageNumber?: number,
    _timestamp?: number  // Added for change detection
}

export interface CompareReportViewTabConfig extends ITabPanelConfig {
    tour?: {
        stepId: string;
    };
}


@Component({
    selector: 'app-compare-report-view',
    imports: [
        SelectComponent,
        MarkdownModule,
        TruncatePipe,
        CommonModule,
        SkeletonModule,
        // CompareChatTabComponent,
        ChatBubbleComponent,
        ButtonComponent,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SplitterModule,
        MatSlideToggleModule,
        DrawerModule,
        ProgressSpinnerModule,
        FormatTextPipe,
        TooltipModule,
        DynamicComponentRenderer,
        AnimateOnScrollModule,
        AccordionModule,
        TimelineModule,
        CardModule,
        CheckboxModule,
        TagModule,
        PopoverModule,
        UserNameDisplayComponent,
        FilterPipe,
        SearchBarComponent,
        TabsPanelsComponent,
        DataTableComponent,
        PopoverComponent,
        DocumentPreviewComponent,
        PdfViewerComponent,
        PanelModule,
        ProgressBarModule,
        DocumentsLoaderComponent,
        DocumentsStackLoaderComponent,
        DocumentsErrorLoaderComponent,
        ToggleComponent,
        SelectModule,
        TableModule,
        InputTextModule,
        Textarea,
        DialogComponent,
        DeleteConfirmationComponent,
        ContractTopBarComponent,
        SupportTicketFormComponent,
        TextCasePipe,
        CaptureIssueComponent,
        CreditsOverviewComponent
    ],
    standalone: true,
    templateUrl: './compare-report-view.component.html',
    styleUrl: './compare-report-view.component.scss',
})
export class CompareReportViewComponent implements OnInit, AfterViewInit, OnDestroy {

    ContractTopBarView = ContractTopBarView;
    SVG = SVG;
    TOP_BAR_SVG = TOP_BAR_SVG;

    // #region Support & Info Menus
    @ViewChild('supportTicketForm') supportTicketFormComponent!: SupportTicketFormComponent;
    @ViewChild('captureIssue') captureIssueComponent!: CaptureIssueComponent;
    supportTicketDialog = false;

    supportMenuItems: CustomMenuItem[] = [
        {
            icon: SVG.RAISE_A_TICKET,
            iconSource: IconSourceEnum.SVG,
            label: 'Raise a support ticket',
            callback: () => this.openHelp(),
        },
        {
            icon: SVG.CAPTURE_AN_ISSUE,
            iconSource: IconSourceEnum.SVG,
            label: 'Capture an issue',
            callback: () => this.openCapture(),
        },
    ];

    infoMenuItems: CustomMenuItem[] = [
        {
            icon: TOP_BAR_SVG.DOCUMENTATION,
            iconSource: IconSourceEnum.SVG,
            label: 'Documentation',
            callback: () => window.open('http://help.doc.inncircles.ai/', '_blank'),
        },
        {
            icon: TOP_BAR_SVG.WEBINARS,
            iconSource: IconSourceEnum.SVG,
            label: 'Webinars',
            callback: () => window.open('https://inncircles.com/join-webinar/', '_blank'),
        },
        {
            icon: TOP_BAR_SVG.WHATS_NEW,
            iconSource: IconSourceEnum.SVG,
            label: "What's New",
            callback: () => window.open('https://inncircles.ai/blogs/', '_blank'),
        },
        {
            icon: TOP_BAR_SVG.QUICK_TOUR,
            iconSource: IconSourceEnum.SVG,
            label: 'Quick Tour',
            callback: () => this.resetWalkthrough(),
        },
    ];
    // #endregion

    // #region Template References & ViewChildren
    @ViewChild('evidenceTemplateRef', { static: true }) evidenceTemplateRef!: TemplateRef<any>;
    @ViewChild('summaryTemplateRef', { static: true }) summaryTemplateRef!: TemplateRef<any>;
    @ViewChild('documentsTemplate', { static: false }) documentsTemplateRef!: TemplateRef<any>;
    @ViewChild('reportTemplate', { static: false }) reportTemplateRef!: TemplateRef<any>;
    @ViewChild('auditLogsTemplate', { static: false }) auditLogsTemplateRef!: TemplateRef<any>;
    showKpiDeleteDialog = false;
    @ViewChild('editableContent') editableContent!: ElementRef;
    @ViewChild('tabsPanels') tabsPanels!: TabsPanelsComponent;

    templatesMap: { [key: string]: TemplateRef<any> } = {};
    // #endregion

    // #region User & Authentication
    currentUser!: IUser | null | undefined;
    // #endregion

    // #region Tabs Management
    tabsConfig: CompareReportViewTabConfig[] = [];
    activeTabValue: string = '0';
    // #endregion

    // #region Core Component State
    loading: boolean = false;
    editName: boolean = false;
    canReRunAnalysis: boolean = false;
    unsorted = () => { return 0 };
    showExport: boolean = false;
    // #endregion

    // #region Document & Comparison Data
    comparisonInfo!: Partial<IDocumentCompare>;
    document!: Partial<IContract>;
    compareDocuments: any[] = [];
    documentsMapping: { [key: string]: IDocumentType } = {};
    tempDocumentsMapping: { [key: string]: IDocumentType } = {};
    selectedDocument: IDocumentType | null = null;
    searchDocument: string = '';
    isComparisonOngoing: boolean = false;
    lastComparisonCompletedDocs: Set<string> = new Set();
    /** True while the bulk "retry failed embeddings" request is in flight. */
    regeneratingEmbeddings: boolean = false;
    // #endregion

    // #region Version Management
    versionOptions: { label: string, value: string }[] = [];
    selectedVersion: string = '';
    // #endregion

    // #region KPI Management
    kpiResult!: { [key: string]: ICompareKpi };

    compareDocumentList: { _id: string; name: string }[] = [];
    kpiDocumentList: { _id: string; name: string }[] = [];
    get documentTypeId(): string { return (this.document as any)?.linkedDocType?._id ?? ''; }
    get areEmbeddingsReady(): boolean {
        return !Object.values(this.documentsMapping).some(
            d => d.embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.IN_PROGRESS
        );
    }

    /**
     * Number of documents in this comparison whose embeddings generation failed.
     * Read from documentsMapping rather than tempDocumentsMapping, which stays empty
     * until the document-selection panel is opened for the first time.
     */
    get failedDocumentCount(): number {
        let count = 0;
        for (const key in this.documentsMapping) {
            if (this.documentsMapping[key].embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.FAILED) {
                count++;
            }
        }
        return count;
    }

    /** Ids of the documents whose embeddings generation failed. */
    private get failedDocumentIds(): string[] {
        return Object.keys(this.documentsMapping).filter(
            key => this.documentsMapping[key].embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.FAILED
        );
    }

    private refreshChatTabLists(): void {
        const mainDoc = this.document ? [{ _id: this.document._id as string, name: this.document.name || '', project: this.document.project }] : [];
        this.compareDocumentList = [
            ...mainDoc,
            ...(this.compareDocuments || []).map((d: any) => ({ _id: d._id, name: d.name || '', project: d.project }))
        ].filter((d: any) => d._id);
        this.kpiDocumentList = Object.entries(this.kpiResult || {})
            .map(([id, kpi]: [string, any]) => ({ _id: id, name: kpi.kpiDoc?.name || '' }));
    }
    selectedKpi!: ICompareKpi | undefined;
    selectedKpiForOverlay: IKpi | null = null;
    kpiDeleteDialogVisible = false;
    kpiDialog: {
        mode: KPI_MODE,
        visible: boolean,
        index: number
    } = { mode: KPI_MODE.ADD, visible: false, index: 0 };
    kpiDialogForm!: IKpi;
    // #endregion

    // #region Report & View Management
    reportViews = [
        {
            value: REPORT_VIEW.FULL_REPORT,
            icon: 'pi pi-chart-line',
            label: 'Full Report'
        },
        {
            value: REPORT_VIEW.MATRIX,
            icon: 'pi pi-table',
            label: 'Compliance Matrix'
        },
        {
            value: REPORT_VIEW.CHART,
            icon: 'pi pi-chart-bar',
            label: 'Chart'
        },
    ];
    selectedReportView: REPORT_VIEW = REPORT_VIEW.FULL_REPORT;
    kpiCheckpoints: { label: string, icon: string, iconColor: string }[] = [
        {
            label: TRACEABILITY_LEVEL.FULLY_TRACEABLE,
            icon: "pi pi-circle-fill",
            iconColor: "text-green-500"
        },
        {
            label: TRACEABILITY_LEVEL.PARTIALLY_TRACEABLE,
            icon: "pi pi-circle-fill",
            iconColor: "text-yellow-500"
        },
        {
            label: TRACEABILITY_LEVEL.NOT_TRACEABLE,
            icon: "pi pi-circle-fill",
            iconColor: "text-red-500"
        }
    ];
    toggleComplianceMatrix: boolean = true;
    // #endregion

    // #region Fullscreen Dialog Management
    fullscreenDialog = {
        visible: false,
        type: '' as FullscreenDialogType,
        title: '',
        class: '',
        size: {}
    };
    currentKpiForDialog: any = null;
    // #endregion

    // #region Panel Management
    rightPanelCollapsed: boolean = false;
    rightPanelActiveTabIndex: number = 0;
    currentPanelSizes: number[] = [70, 30];
    lastPanelSizes: number[] = [70, 30];
    rightPanelSize: number = 30;
    isRightGutterResizing: boolean = false;
    resizeStartSizes: number[] = [];
    // #endregion

    // #region Chat Integration
    ChatSource = ChatSource;
    chatSuggestions: string[] = [
        'At what percentages the Daily/Weekly/Monthly rates changed ',
        'What is the highest rate increase in terms of monetary value and percentage for a specific item ?',
        'List the items that faced a rate decrease',
        'Which items had no change in their rates ?',
        'Which is the best quote among these quotes ?',
        'Compare the rates in the tables and give a synopsis'
    ];
    compareType!: DOCUMENT_MODEL.CONTRACT;
    agentModeEnabled: boolean = false;
    // #endregion

    // #region Download & Export Management
    downloadReportLoading: downloadMode | null = null;
    downloadMatrixLoading: downloadMode | null = null;
    downloadOverallLoading: boolean = false;
    downloadKpiLoading: string = '';
    reportUrl: string = '';
    showReportPreview: boolean = false;
    previewTitle: string = '';
    // #endregion

    // #region Audit Logs Management
    auditLogs: IAuditLog[] = [];
    loadingAuditLogs: boolean = false;
    showKpiAuditLogsDialog = false;
    kpiAuditLogs: IAuditLog[] = [];
    showAuditsExportDialog = false;
    // #endregion

    // #region Tour/Walkthrough Properties
    driver?: Driver;
    currentStepNumber: number = 0;
    // #endregion

    // #region Enums & Constants
    COMPARE_DOCUMENT_STATUS = COMPARE_DOCUMENT_STATUS;
    EMBEDDINGS_GENERATION_STATUS = EMBEDDINGS_GENERATION_STATUS;
    FullscreenDialogType = FullscreenDialogType;
    REPORT_VIEW = REPORT_VIEW;
    COMMENTS_TYPE = COMMENTS_TYPE;
    // #endregion

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthenticationService,
        private compareService: CompareService,
        private toast: ToastService,
        private cdr: ChangeDetectorRef,
        public collapsiblePanelService: CollapsiblePanelService,
        private socketService: SocketService,
        private dialogService: DialogService,
        private auditLogService: AuditLogService,
        private productWalkThroughService: ProductWalkThroughService,
        private chatSidebarService: ChatSidebarService,
        private supportTicketDialogService: SupportTicketDialogService
    ) {
        this.authService.currentUser.subscribe(res => {
            this.currentUser = res
        });
        if (this.currentUser?.role ? [USER_ROLE.ADMIN, USER_ROLE.SUPER_ADMIN].includes(this.currentUser.role) : false) {
            this.showExport = true;
        }
        this.route.queryParamMap.subscribe(params => {
            let compareId = params.get('comparisonId') as string;
            this.comparisonInfo = {
                _id: compareId
            }
            this.emitSocketEvent(CLIENT_EVENTS.JOIN_COMPARE_ROOM)
            // Register compare room for automatic reconnection
            if (this.comparisonInfo._id) {
                this.socketService.registerRoom(`compare_${this.comparisonInfo._id}`, CLIENT_EVENTS.JOIN_COMPARE_ROOM, this.comparisonInfo._id);
            }
        });
    }

    // #region Lifecycle Hooks
    ngOnInit(): void {
        // Initialize templates map
        this.templatesMap = {
            'evidenceTemplate': this.evidenceTemplateRef,
            'summaryTemplate': this.summaryTemplateRef
        };

        // Initialize tabs configuration
        this.initializeTabsConfig();

        // Initialize panel sizes to ensure correct button positioning
        this.initializePanelSizes();

        this.supportTicketDialogService.openDialog$.subscribe(payload => {
            if (payload.attachment && this.supportTicketFormComponent) {
                this.supportTicketFormComponent.attachmentFiles.push(payload.attachment.file);
                this.supportTicketFormComponent.attachmentPreviews.push(payload.attachment);
            }
            this.supportTicketDialog = true;
        });

        this.productWalkThroughService.walkThroughReset$.subscribe((type: PRODUCT_WALKTHROUGH_TYPE) => {
            if (type === PRODUCT_WALKTHROUGH_TYPE.COMPARE) {
                this.resetWalkthrough();
            }
        });

        this.socketService.on(SOCKET_EVENTS.COMPARE_KPI_UPDATE).subscribe((data: any) => {
            if (data[0]) {
                if (data[0]?.compareId === this.comparisonInfo._id) {
                    this.handleSocketEvent(data[0])
                }
            }
        });

        this.socketService.on<{ status: EMBEDDINGS_GENERATION_STATUS, item: string }>(SOCKET_EVENTS.EMBEDDINGS_STATUS_UPDATE).subscribe(res => {
            const update = res?.[0];
            // Guard the lookup: these events are not scoped to this comparison, so one can
            // arrive for a document that is not part of it. Patch just that document rather
            // than re-cloning the whole map, which would discard uncommitted panel edits.
            if (update?.item && this.documentsMapping[update.item]) {
                this.setEmbeddingsStatus(update.item, update.status);
            }
        })

        if (this.comparisonInfo?._id) {
            this.selectedVersion = this.comparisonInfo._id
            this.getComparison();
            this.getAuditLogs();
        }
    }

    ngAfterViewInit(): void {
        // Trigger a small delay to ensure the splitter has rendered and then fix button positioning
        setTimeout(() => {
            // Force a change detection cycle to update button positions
            this.cdr.detectChanges();
        }, 100);
    }

    ngOnDestroy(): void {
        // Unregister compare room on component destruction
        if (this.comparisonInfo._id) {
            this.socketService.unregisterRoom(`compare_${this.comparisonInfo._id}`);
        }
        if (this.chatSidebarService.isOpen()) {
            this.chatSidebarService.close();
        }
    }
    // #endregion

    // #region Navigation & Utility Methods
    goBack() {
        window.close();
        // Case : when window.close() fails for copied compare url 
        if (this.document?._id) {
            this.router.navigate(['/edit-document'], { queryParams: { documentId: this.document._id } });
        } else {
            this.router.navigate(['/']);
        }
    }

    blurSpan(event: Event) {
        const target = event.target as HTMLElement;
        target.blur();
    }

    enableEditing() {
        this.editName = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.editableContent.nativeElement.focus();
        }, 0);
    }

    updateCompareName(event: Event) {
        event.preventDefault()
        const target = event.target as HTMLElement;
        const newName = target.textContent?.trim() || 'Untitled';
        target.innerHTML = newName
        if (this.comparisonInfo.name && this.comparisonInfo.name !== newName) {
            this.comparisonInfo.name = newName;
            if (this.comparisonInfo._id && this.comparisonInfo.name) {
                this.compareService.updateComparisonName(this.comparisonInfo._id, this.comparisonInfo.name).subscribe((res) => {
                    if (res && res.success) {
                        this.editName = false;
                        this.toast.success("Name updated successfully")
                        this.getComparisonHistory();
                    }
                });
            }
        }
    }

    compareVersionChange(comparisonId: string) {
        // Unregister old room if it exists
        if (this.comparisonInfo._id) {
            this.socketService.unregisterRoom(`compare_${this.comparisonInfo._id}`);
        }
        this.comparisonInfo._id = comparisonId
        this.emitSocketEvent(CLIENT_EVENTS.JOIN_COMPARE_ROOM)
        // Register new room
        if (this.comparisonInfo._id) {
            this.socketService.registerRoom(`compare_${this.comparisonInfo._id}`, CLIENT_EVENTS.JOIN_COMPARE_ROOM, this.comparisonInfo._id);
        }
        this.getComparison();
        this.getAuditLogs();
    }
    // #endregion

    // #region Socket Event Management
    async emitSocketEvent(event: CLIENT_EVENTS) {
        if (this.comparisonInfo._id) {
            const socket = await this.socketService.getSocket()
            if (!socket) {
                console.warn('Socket is not initialized yet:', event)
                return
            }
            socket.emit(event as CLIENT_EVENTS.JOIN_COMPARE_ROOM | CLIENT_EVENTS.LEAVE_COMPARE_ROOM, this.comparisonInfo._id)
        }
    }
    // #endregion

    // #region Data Fetching & Management
    getComparison() {
        this.loading = true;
        if (this.comparisonInfo._id) {
            this.compareService.getComparison(this.comparisonInfo._id).subscribe({
                next: (res) => {
                    if (res && res.success) {
                        this.loading = false;
                        this.comparisonInfo = res.data;
                        this.document = this.comparisonInfo.contract as Partial<IContract>;
                        this.getComparisonHistory()
                        this.compareDocuments = (this.comparisonInfo?.compareContracts || []).map((doc: any) => {
                            return {
                                _id: doc._id,
                                docModel: doc.docModel,
                                name: doc.docModel == DOCUMENT_MODEL.UPLOADED_DOCUMENT ? doc.doc?.filename : doc.doc?.name,
                                embeddingsStatus: doc.embeddingsStatus,
                                attachment: doc.doc?.attachment || doc.attachment,
                                linkedDocType: doc.doc?.linkedDocType,
                                project: doc.doc?.project
                            }
                        });
                        // this.documentsUsedForComparison = this.comparisonInfo?.status?.kpis === COMPARE_DOCUMENT_STATUS.COMPLETED
                        //     ? this.comparisonInfo.status.documents
                        //     : (this.comparisonInfo.compareContracts || []).filter(doc => doc.embeddingsStatus == EMBEDDINGS_GENERATION_STATUS.COMPLETED).map(doc => doc._id) ?? [];

                        this.documentsMapping = {
                            [this.document?._id ?? '']: {
                                _id: this.document?._id ?? '',
                                name: this.document?.name ?? '',
                                linkedDocTypeName: this.document?.linkedDocType?.name ?? '',
                                highlightCount: 0,
                                attachment: this.document?.attachment as IAttachment,
                                embeddingsStatus: EMBEDDINGS_GENERATION_STATUS.COMPLETED,
                                mainDocument: true,
                                consideredForComparison: (this.comparisonInfo?.status?.documents || []).includes(this.document?._id ?? ''),
                                consideredWithLinkedDocs: (this.comparisonInfo?.status?.linkedDocuments || []).includes(this.document?._id ?? ''),
                            }
                        }
                        this.compareDocuments.forEach(doc => {
                            this.documentsMapping[doc._id] = {
                                _id: doc._id,
                                name: doc.name,
                                linkedDocTypeName: doc.linkedDocType?.name ?? '',
                                highlightCount: 0,
                                attachment: doc.attachment as IAttachment,
                                embeddingsStatus: doc.embeddingsStatus,
                                mainDocument: false,
                                consideredForComparison: (this.comparisonInfo?.status?.documents || []).includes(doc?._id ?? ''),
                                consideredWithLinkedDocs: (this.comparisonInfo?.status?.linkedDocuments || []).includes(doc?._id ?? ''),
                            }
                        });
                        // Set initial document with proper structure for change detection
                        const initialDoc = this.documentsMapping?.[this.document?._id ?? ''];
                        if (initialDoc) {
                            this.selectedDocument = {
                                ...initialDoc,
                                pageNumber: 1,
                                _timestamp: Date.now()
                            };

                            // Force change detection for initial document load
                            this.cdr.detectChanges();
                        }

                        this.canReRunAnalysis = false;

                        // Populate document options for multi-select dropdown
                        // this.updateDocumentOptions();
                        this.kpiResult = {}
                        for (let kpi of this.comparisonInfo.kpis as IDocumentCompare['kpis']) {
                            if (!this.kpiResult) {
                                this.kpiResult = {}
                            }
                            if (!this.kpiResult[(kpi.kpi as IKpi)?._id as string]) {
                                const { report, matrix, sources } = this.fetchReportMatrixSources(kpi.comparison as string ?? '');
                                this.kpiResult[(kpi.kpi as IKpi)?._id as string] = {
                                    kpi: (kpi.kpi as IKpi)?._id?.toString() ?? '',
                                    kpiDoc: kpi.kpi as IKpi,
                                    expanded: false,
                                    kpiData: {
                                        conclusions: [],
                                        full_plan: [],
                                        final_response: kpi.comparison as string ?? '',
                                        report: report as string ?? '',
                                        matrix: matrix,
                                        sources: sources as any,
                                        total_time: 0
                                    },
                                    // Status is already enriched from ThreadMetadata by the backend
                                    kpiStatus: kpi.status as COMPARE_DOCUMENT_STATUS ?? COMPARE_DOCUMENT_STATUS.PENDING,
                                    // Carry pauseReason so the UI can distinguish credits_exhausted from generic errors
                                    pauseReason: kpi.pauseReason ?? null,
                                }
                            }


                        }
                        this.updateComparisonResult(Object.keys(this.kpiResult).length > 0)
                        this.refreshChatTabLists();
                        this.loading = false;
                        // this.checkWalkThrough()
                    } else {
                        // this.compareSummary = 'No comparison result found';
                        this.loading = false;
                        // this.checkWalkThrough()
                    }
                },
                error: (error) => {
                    console.error('Error fetching comparison:', error);
                    this.loading = false;
                    this.toast.error('Failed to load comparison. Please try again.');
                }
            });
        }
    }

    getComparisonHistory() {
        this.compareService.getHistory(this.document?._id ?? '').subscribe((res) => {
            if (res.success) {
                this.versionOptions = (res.data || []).map(item => {
                    return {
                        label: item.name,
                        value: item._id
                    }
                })
            }
        })
    }
    // #endregion

    // #region Comparison Analysis & Processing
    updateComparisonResult(fetchKpi: boolean = true, kpi?: { _id?: string, name?: string, description?: string, mode: KPI_MODE }) {
        let payload = {};
        if (this.canReRunAnalysis) {
            payload = {
                documentsToBeCompared: Object.keys(this.documentsMapping).filter(key => this.documentsMapping[key].consideredForComparison && this.documentsMapping[key].embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.COMPLETED).map(key => this.documentsMapping[key]._id),
                linkedDocumentsToBeCompared: Object.keys(this.documentsMapping).filter(key => this.documentsMapping[key].consideredWithLinkedDocs && this.documentsMapping[key].embeddingsStatus === EMBEDDINGS_GENERATION_STATUS.COMPLETED).map(key => this.documentsMapping[key]._id)
            }
        }
        if (kpi) {
            payload = {
                ...payload,
                kpi: JSON.stringify(kpi)
            }
        }
        this.canReRunAnalysis = false;
        if (fetchKpi) {
            this.getCompareKpiResult(payload);
        }
    }

    getCompareKpiResult(data?: { documentsToBeCompared?: string[], linkedDocumentsToBeCompared?: string[] }) {
        const payload = {
            comparisonId: this.comparisonInfo._id ?? '',
            ...(data?.documentsToBeCompared ? { documentsToBeCompared: data?.documentsToBeCompared } : {}),
            ...(data?.linkedDocumentsToBeCompared ? { linkedDocumentsToBeCompared: data?.linkedDocumentsToBeCompared } : {})
        }
        this.compareService.getCompareKpiResult(payload).subscribe((res) => {
            if (res && res.success) {

            }
        })
    }


    fetchReportMatrixSources(report: string) {
        const full_report = report as string ?? '';
        if (!full_report) {
            return {
                report: '',
                matrix: [],
                sources: []
            }
        }
        const parsed_report = JSON.parse(full_report);
        const report_data = parsed_report?.['compare_report'] ?? '';
        const matrix = parsed_report?.['compliance_matrix'] ?? '';
        const parsed_matrix = matrix ? JSON.parse(matrix) : [];

        const compliance_result = parsed_matrix ?? [];
        const sources = parsed_report?.['evidence_sources'] ?? '';
        const sources_parsed = sources ? JSON.parse(sources) : [];
        return {
            report: report_data,
            matrix: compliance_result.compliance_matrix || compliance_result,
            sources: sources_parsed
        }
    }



    getProgressBarData(matrix: ICompareMatrix[]) {
        const matrixData = matrix;
        if (!matrixData || matrixData.length === 0) {
            return [];
        }

        return matrixData.map(item => ({
            entity: item.entity || 'Unknown',
            score: parseFloat(item.score.toString()) || 0,
            severity: this.getScoreSeverity(parseFloat(item.score.toString()) || 0)
        }));
    }

    getScoreSeverity(score: number): string {
        if (score >= 80) return 'success';
        if (score >= 60) return 'warning';
        return 'danger';
    }
    // #endregion

    // #region Document Management
    onSearchDocument(event: any) {
        this.searchDocument = event.target.value;
    }

    selectDocument(doc: IDocumentType, pageNumber: number = 1) {
        // Always create a completely new object with a timestamp to force change detection
        this.selectedDocument = {
            ...doc,
            pageNumber: pageNumber,
            _timestamp: Date.now() // Add timestamp to ensure object reference changes
        };

        // Open Documents tab (index 0) and expand right panel if collapsed
        this.openDocumentsTabAndExpandPanel();

        // Force change detection
        this.cdr.detectChanges();
    }

    isPdfDocument(doc: any): boolean {
        if (!doc?.attachment?.type) {
            return false;
        }
        const isPdf = doc.attachment.type.toLowerCase().includes('pdf') ||
            doc.attachment.filename?.toLowerCase().endsWith('.pdf') ||
            doc.attachment.fullUrl?.toLowerCase().includes('.pdf');

        return isPdf;
    }

    getDocumentTrackKey(doc: IDocumentType): string {
        return `${doc._id}-${doc.pageNumber ?? 1}-${doc._timestamp ?? Date.now()}`;
    }

    openDocumentsTabAndExpandPanel(): void {
        // Expand right panel if it's collapsed
        if (this.rightPanelCollapsed) {
            this.toggleRightPanel();
        }

        // Switch to Documents tab (index 0) by triggering tab change
        // The Documents tab is the first tab in the right panel TabView
        // We'll set a property to track the active tab index for the right panel
        this.rightPanelActiveTabIndex = 0;
        this.activeTabValue = '0';

        if (this.tabsPanels) {
            this.tabsPanels.setActiveTab('0');
        }
    }

    /**
     * Handles tab change events from the tabs component
     * @param event - Tab change event containing the new tab value
     */
    onTabChanged(event: any): void {
        const value = event.value || event.index?.toString() || '0';
        this.activeTabValue = value;
        this.rightPanelActiveTabIndex = parseInt(value);
    }

    /**
     * Initializes the tabs configuration for the right panel with component-based content
     */
    initializeTabsConfig(): void {
        this.tabsConfig = [
            {
                value: '0',
                label: 'Documents',
                icon: 'pi pi-file',
                visible: true,
                component: CompareDocumentsTabComponent,
                tour: {
                    stepId: 'compare-step7'
                },
                data: {
                    parentComponent: this
                }
            },
            {
                value: '1',
                label: 'Reports',
                icon: 'pi pi-chart-bar',
                visible: true,
                component: CompareReportsTabComponent,
                tour: {
                    stepId: 'compare-step8'
                },
                data: {
                    parentComponent: this
                }
            },
            {
                value: '2',
                label: 'Audit Log',
                icon: 'pi pi-history',
                visible: true,
                component: CompareAuditLogTabComponent,
                tour: {
                    stepId: 'compare-step9'
                },
                data: {
                    parentComponent: this
                }
            },
            {
                value: '3',
                label: 'Comments',
                icon: 'pi pi-comment',
                visible: true,
                component: CompareCommentsTabWrapperComponent,
                tour: {
                    stepId: 'compare-step10'
                },
                data: {
                    comparisonId: this.comparisonInfo._id ?? '',
                    commentsType: COMMENTS_TYPE.COMPARISON
                }
            }
        ];
    }

    /**
     * Initialize temporary documents mapping when panel opens
     */
    onDocumentSelectionPanelOpen(): void {
        // Create a deep copy of the current documentsMapping to avoid reference issues
        this.tempDocumentsMapping = structuredClone(this.documentsMapping);

    }

    /**
     * Handle panel close without saving changes
     */
    onDocumentSelectionPanelClose(): void {
        // Reset temp variable and canReRunAnalysis flag
        this.tempDocumentsMapping = {};
        this.canReRunAnalysis = false;
    }

    /**
     * Apply temporary changes to original documentsMapping and trigger re-analysis
     */
    confirmDocumentSelectionChanges(): void {
        // Copy changes from temp to original
        for (const key in this.tempDocumentsMapping) {
            if (this.documentsMapping[key]) {
                this.documentsMapping[key].consideredForComparison = this.tempDocumentsMapping[key].consideredForComparison;
                this.documentsMapping[key].consideredWithLinkedDocs = this.tempDocumentsMapping[key].consideredWithLinkedDocs;
            }
        }

        // Trigger re-analysis
        this.updateComparisonResult(Object.keys(this.kpiResult).length > 0);
        this.toast.success("Comparison re-analysis starting...")

        // Reset temp variable and flag
        this.tempDocumentsMapping = {};
        this.canReRunAnalysis = false;
    }

    /**
     * Handle changes in temp document selection
     */
    onTempDocumentSelectionChange(): void {
        this.canReRunAnalysis = Object.keys(this.tempDocumentsMapping).some(key =>
            this.tempDocumentsMapping[key].consideredForComparison !== this.documentsMapping[key].consideredForComparison
        ) //at lease one document is consideration value changed
            && Object.keys(this.tempDocumentsMapping).some(key => !this.tempDocumentsMapping[key].mainDocument && this.tempDocumentsMapping[key].consideredForComparison); //at lease one compare document is considered
    }

    /**
     * Re-trigger embeddings generation for every document of this comparison whose
     * embeddings failed. Statuses move to IN_PROGRESS optimistically; the
     * EMBEDDINGS_STATUS_UPDATE socket event drives them to their final state.
     * The backend restarts the comparison itself once all of them have settled, so
     * nothing here re-runs the analysis.
     */
    retryFailedEmbeddings(): void {
        const comparisonId = this.comparisonInfo?._id;
        const failedIds = this.failedDocumentIds;
        if (!comparisonId || this.regeneratingEmbeddings || !failedIds.length) {
            return;
        }
        this.regeneratingEmbeddings = true;
        this.compareService.regenerateFailedEmbeddings(comparisonId).subscribe({
            next: (res) => {
                this.regeneratingEmbeddings = false;
                if (res && res.success) {
                    failedIds.forEach(id => this.setEmbeddingsStatus(id, EMBEDDINGS_GENERATION_STATUS.IN_PROGRESS));
                    this.toast.success(`Regenerating ${failedIds.length} document(s). The comparison will restart automatically once they are ready.`);
                } else {
                    this.toast.error(res?.message || 'Failed to regenerate embeddings. Please try again.');
                }
            },
            error: (error) => {
                console.error('Error regenerating failed embeddings:', error);
                this.regeneratingEmbeddings = false;
                this.toast.error('Failed to regenerate embeddings. Please try again.');
            }
        });
    }

    /**
     * Keep both the live and the panel's temporary mapping in sync with a status change
     */
    private setEmbeddingsStatus(documentId: string, status: EMBEDDINGS_GENERATION_STATUS): void {
        if (this.documentsMapping[documentId]) {
            this.documentsMapping[documentId].embeddingsStatus = status;
        }
        if (this.tempDocumentsMapping[documentId]) {
            this.tempDocumentsMapping[documentId].embeddingsStatus = status;
        }
        this.compareDocuments = Object.values(this.documentsMapping);
        this.chatSidebarService.updateConfig({ embeddingsStatus: this.areEmbeddingsReady ? EMBEDDINGS_GENERATION_STATUS.COMPLETED : EMBEDDINGS_GENERATION_STATUS.IN_PROGRESS });
    }
    // #endregion

    // #region KPI Management
    openAddKPIDialog(mode: KPI_MODE = KPI_MODE.ADD) {
        this.kpiDialogForm = {
            name: '',
            description: '',
            data_type: KPI_DATA_TYPE.TEXT
        }
        this.kpiDialog.visible = true
        this.kpiDialog.mode = mode
    }

    onKPIDialogClose() {
        this.kpiDialogForm = {
            name: '',
            description: '',
            data_type: KPI_DATA_TYPE.TEXT
        }
    }

    editKpi(kpiId: string) {
        this.kpiDialogForm = {
            _id: kpiId,
            name: this.kpiResult[kpiId].kpiDoc.name,
            description: this.kpiResult[kpiId].kpiDoc.description,
            data_type: this.kpiResult[kpiId].kpiDoc.data_type
        }
        this.kpiDialog.visible = true
        this.kpiDialog.mode = KPI_MODE.EDIT
    }

    saveKpi() {
        if (!this.kpiDialogForm?.name?.trim()?.length || !this.kpiDialogForm?.description?.trim()?.length) {
            return this.toast.warn("Please fill all the required fields")
        }
        if (this.kpiDialog.mode === KPI_MODE.EDIT) {
            //check if the kpi name is already in use
            for (let kpiId in this.kpiResult) {
                if (kpiId != this.kpiDialogForm._id && this.kpiResult[kpiId].kpiDoc.name === this.kpiDialogForm.name) {
                    return this.toast.warn("KPI name already in use")
                }
            }
        }
        this.kpiDialog.visible = false
        this.compareService.generateKpi({
            comparisonId: this.comparisonInfo._id ?? '',
            kpi: {
                _id: this.kpiDialogForm._id,
                name: this.kpiDialogForm.name,
                description: this.kpiDialogForm.description,
                mode: this.kpiDialog.mode
            }
        }).subscribe((res) => {
            if (res && res.success) {
                if (res.data._id) {
                    let newStatus = COMPARE_DOCUMENT_STATUS.PENDING
                    if (this.kpiDialog.mode === KPI_MODE.EDIT) {
                        newStatus = this.kpiResult[res.data._id].kpiStatus
                        if (this.kpiResult[res.data._id].kpiDoc.description.trim() != this.kpiDialogForm.description.trim()) {
                            newStatus = COMPARE_DOCUMENT_STATUS.PENDING
                        }
                    }
                    if (newStatus === COMPARE_DOCUMENT_STATUS.PENDING) {
                        this.kpiResult[res.data._id] = {
                            kpi: res.data._id,
                            kpiDoc: res.data,
                            expanded: false,
                            kpiData: {
                                conclusions: [],
                                full_plan: [],
                                final_response: '',
                                report: '',
                                matrix: [],
                                sources: [],
                                total_time: 0
                            },
                            kpiStatus: newStatus
                        }
                    }
                    else {
                        this.kpiResult[res.data._id] = {
                            ...this.kpiResult[res.data._id],
                            kpi: res.data._id,
                            kpiDoc: res.data,
                            expanded: false
                        }
                    }
                }
                this.kpiDialogForm = {
                    name: '',
                    description: '',
                    data_type: KPI_DATA_TYPE.TEXT
                }
                this.toast.success("KPI saved successfully")
            } else {
                this.toast.error("Failed to save KPI")
                this.kpiDialogForm = {
                    name: '',
                    description: '',
                    data_type: KPI_DATA_TYPE.TEXT
                }
            }
        })

    }


    confirmDeleteKpi(kpiId?: string) {
        if (kpiId) {
            this.selectedKpiForOverlay = this.kpiResult[kpiId].kpiDoc;
        }
        this.showKpiDeleteDialog = true;
    }

    deleteKpi() {
        this.showKpiDeleteDialog = false;
        this.compareService.removeKpi(this.comparisonInfo._id ?? '', this.selectedKpiForOverlay?._id ?? '').subscribe((res) => {
            if (res && res.success) {
                delete this.kpiResult[this.selectedKpiForOverlay?._id ?? ''];
                this.refreshChatTabLists();
                this.kpiDeleteDialogVisible = false;
                this.toast.success("KPI deleted successfully");
            } else {
                this.toast.error("Failed to delete KPI");
            }
        });
    }

    retryKpiGeneration(kpiId: string) {
        if (!kpiId) {
            this.toast.error("Failed to retry KPI generation");
            return;
        }
        this.compareService.generateKpi({
            comparisonId: this.comparisonInfo._id ?? '',
            kpi: {
                _id: kpiId,
                mode: KPI_MODE.RETRY
            }
        }).subscribe({
            next: (res) => {
                if (res && res.success) {
                    const retriedId = res.data?._id ?? kpiId;
                    if (this.kpiResult[retriedId]) {
                        this.kpiResult[retriedId] = {
                            ...this.kpiResult[retriedId],
                            kpiData: {
                                conclusions: [],
                                full_plan: [],
                                final_response: '',
                                report: '',
                                matrix: [],
                                sources: [],
                                total_time: 0
                            },
                            kpiStatus: COMPARE_DOCUMENT_STATUS.PENDING,
                            // Clear the credits-exhausted reason so the credits card hides on retry
                            pauseReason: null
                        }
                    }
                    this.toast.success("Retry KPI generation started")
                } else {
                    this.toast.error(res?.message || "Failed to retry KPI generation")
                }
            },
            error: (err) => {
                console.error('Failed to retry KPI generation', err);
                this.toast.error("Failed to retry KPI generation")
            }
        })
    }

    
    resumeKpiGeneration(kpiId: string) {
        if (!kpiId) {
            this.toast.error("Failed to resume KPI generation");
            return;
        }
        this.compareService.generateKpi({
            comparisonId: this.comparisonInfo._id ?? '',
            kpi: {
                _id: kpiId,
                mode: KPI_MODE.RESUME
            }
        }).subscribe({
            next: (res) => {
                if (res && res.success) {
                    const resumedId = res.data?._id ?? kpiId;
                    if (this.kpiResult[resumedId]) {
                        this.kpiResult[resumedId] = {
                            ...this.kpiResult[resumedId],
                            kpiStatus: COMPARE_DOCUMENT_STATUS.IN_PROGRESS,
                            pauseReason: null
                        }
                    }
                    this.toast.success("Resume KPI generation started")
                } else {
                    this.toast.error(res?.message || "Failed to resume KPI generation")
                }
            },
            error: (err) => {
                console.error('Failed to resume KPI generation', err);
                this.toast.error("Failed to resume KPI generation")
            }
        })
    }

    stopKpiGeneration(kpiId: string) {
        this.compareService.stopKpiGeneration(this.comparisonInfo._id ?? '', kpiId).subscribe((res) => {
            if (res && res.success) {
                this.toast.success("KPI generation stopped")
                this.kpiResult[kpiId].kpiStatus = COMPARE_DOCUMENT_STATUS.ERROR
            } else {
                this.toast.error("Failed to stop KPI generation")
            }
        })
    }
    // #endregion

    // #region Report Generation & Download

    downloadComparison(data: { showComplianceMatrix: boolean, showChart: boolean, showFullReport: boolean }, kpiId: string = '', mode: downloadMode = 'download') {
        if (kpiId) {
            this.downloadKpiLoading = kpiId
        }
        else {
            if (data.showComplianceMatrix && data.showChart && data.showFullReport) {
                this.downloadOverallLoading = true
            }
            else if (data.showComplianceMatrix) {
                this.downloadMatrixLoading = mode
            }
            else if (data.showFullReport) {
                this.downloadReportLoading = mode
            }
        }
        this.compareService.downloadComparison({ comparisonId: this.comparisonInfo._id ?? '', ...data, kpiId, mode }).subscribe({
            next: (res) => {
                if (res) {
                    const blob: Blob = new Blob([new Uint8Array(res.data.data)], {
                        type: 'application/pdf'
                    });
                    switch (mode) {
                        case 'preview':
                            this.reportUrl = URL.createObjectURL(blob);
                            this.showReportPreview = true;
                            this.previewTitle = data.showFullReport ? 'Executive Summary' : data.showComplianceMatrix ? 'Compliance Matrix' : '';
                            setTimeout(() => URL.revokeObjectURL(url), 1000);
                            break;
                        case 'download':
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = `Comparison.pdf`;
                            document.body.append(link);
                            link.click();
                            link.remove();
                            // this.downloadLoading = false;
                            break;
                        case 'open':
                            const url = URL.createObjectURL(blob);
                            window.open(url, '_blank');
                            setTimeout(() => URL.revokeObjectURL(url), 1000);
                            break;
                    }

                    this.downloadOverallLoading = false;
                    this.downloadMatrixLoading = null;
                    this.downloadReportLoading = null;
                    this.downloadKpiLoading = '';
                }
            },
            error: () => {
                this.downloadOverallLoading = false;
                this.downloadMatrixLoading = null;
                this.downloadReportLoading = null;
                this.downloadKpiLoading = '';
                this.toast.error('Failed to generate report. Please try again.');
            }
        })
    }
    closeReportPreview() {
        this.showReportPreview = false;
        this.reportUrl = '';
        this.previewTitle = '';
    }
    // #endregion

    // #region Audit Logs Management
    getAuditLogs(showToast: boolean = false) {
        this.loadingAuditLogs = true;
        this.auditLogService.getAuditLogs(AUDIT_MODULE.COMPARE, { compareId: this.comparisonInfo._id ?? '' }).subscribe((res) => {
            this.loadingAuditLogs = false;
            if (res && res.success) {
                this.auditLogs = res.data;
                if (showToast) {
                    this.toast.success("Audit logs fetched successfully");
                }
            } else {
                if (showToast) {
                    this.toast.error("Failed to fetch audit logs");
                }
            }
        })
    }

    getKpiAuditLogs(kpiId: string) {
        this.kpiDialogForm = {
            _id: kpiId,
            name: this.kpiResult[kpiId].kpiDoc.name,
            description: this.kpiResult[kpiId].kpiDoc.description,
            data_type: this.kpiResult[kpiId].kpiDoc.data_type
        }
        this.auditLogService.getAuditLogs(AUDIT_MODULE.COMPARE, { compareId: this.comparisonInfo._id ?? '', kpiId: kpiId }).subscribe((res) => {
            if (res && res.success) {
                this.kpiAuditLogs = res.data;
            } else {
                this.toast.error("Failed to fetch audit logs");
            }
            this.showKpiAuditLogsDialog = true;
        })
    }

    closeKpiAuditLogsDialog() {
        this.showKpiAuditLogsDialog = false;
        this.kpiAuditLogs = [];
        this.kpiDialogForm = {
            _id: '',
            name: '',
            description: '',
            data_type: KPI_DATA_TYPE.TEXT
        }
    }

    exportAuditsToExcel() {
        if (this.comparisonInfo._id === undefined) {
            return this.toast.error("Failed to download audit logs excel");
        }
        const data = {
            comparisonId: this.comparisonInfo._id,
            type: DOWNLOAD_AUDIT_LOGS_TYPE.EXCEL,
            ...(this.kpiDialogForm?._id ? { kpiId: this.kpiDialogForm._id } : {})
        }
        this.compareService.downloadCompareAuditLogs(data).subscribe({
            next: (res) => {
                if (res.data && res.success) {
                    const blob = new Blob([new Uint8Array(res.data.data)], { type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
                    saveAs(blob, 'Audit_Excel_Report.xlsx');
                    this.toast.success("Successfully downloaded audit logs excel");
                }
                else {
                    this.toast.error("Failed to download audit logs excel");
                }
            },
            error: () => {
                this.toast.error("Failed to download audit logs excel");
            }
        })
        this.showAuditsExportDialog = false;
    }

    exportAuditsToPDF() {
        if (this.comparisonInfo._id === undefined) {
            return this.toast.error("Failed to download audit logs pdf");
        }
        const data = {
            comparisonId: this.comparisonInfo._id,
            type: DOWNLOAD_AUDIT_LOGS_TYPE.PDF,
            ...(this.kpiDialogForm?._id ? { kpiId: this.kpiDialogForm._id } : {})
        }
        this.compareService.downloadCompareAuditLogs(data).subscribe({
            next: (res) => {
                if (res && res.success) {
                    const blob: Blob = new Blob([new Uint8Array(res.data.data)], {
                        type: 'application/pdf'
                    });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = `Audit-Logs-Report.pdf`;
                    document.body.append(link);
                    link.click();
                    link.remove();
                    this.toast.success("Successfully downloaded audit logs pdf");
                }
                else {
                    this.toast.error("Failed to download audit logs pdf");
                }
            },
            error: () => {
                this.toast.error("Failed to download audit logs pdf");
            }
        })
        this.showAuditsExportDialog = false;
    }
    // #endregion

    // #region Socket Event Management
    handleSocketEvent(data: ICompareSocketsResponse) {
        if (data.event === COMPARE_SOCKETS_EVENTS.COMPARE_LEVEL_STATUS) {
            this.comparisonInfo = {
                ...this.comparisonInfo,
                status: {
                    documents: this.comparisonInfo.status?.documents || [],
                    linkedDocuments: this.comparisonInfo.status?.linkedDocuments || [],
                    summary: this.comparisonInfo.status?.summary || COMPARE_DOCUMENT_STATUS.PENDING,
                    kpis: data.status as COMPARE_DOCUMENT_STATUS
                }
            }
            // Update per-KPI status and pauseReason from the bulk kpiStatuses payload
            if (data.kpiId === null && data.kpiStatuses?.length) {
                data.kpiStatuses.forEach((item) => {
                    const existing = this.kpiResult[item.kpiId];
                    if (existing) {
                        this.kpiResult[item.kpiId] = {
                            ...existing,
                            kpiStatus: item.status,
                            // Keep the existing pauseReason for a still-PAUSED KPI when the
                            // payload doesn't carry one — prevents a credits-exhausted card
                            // from vanishing when another KPI of the compare is resumed.
                            pauseReason: item.status === COMPARE_DOCUMENT_STATUS.PAUSED
                                ? (item.pauseReason ?? existing.pauseReason ?? null)
                                : (item.pauseReason ?? null),
                        };
                    }
                });
            }
            if (data.status === COMPARE_DOCUMENT_STATUS.COMPLETED || data.status === COMPARE_DOCUMENT_STATUS.ERROR || data.status === COMPARE_DOCUMENT_STATUS.PAUSED) {
                this.isComparisonOngoing = false;
            }
        }
        if (data.event === COMPARE_SOCKETS_EVENTS.COMPARE_KPI_DATA) {
            if (data.kpiStatus === COMPARE_DOCUMENT_STATUS.IN_PROGRESS) {
                this.comparisonInfo = {
                    ...this.comparisonInfo,
                    status: {
                        documents: this.comparisonInfo.status?.documents || [],
                        linkedDocuments: this.comparisonInfo.status?.linkedDocuments || [],
                        summary: this.comparisonInfo.status?.summary || COMPARE_DOCUMENT_STATUS.PENDING,
                        kpis: COMPARE_DOCUMENT_STATUS.IN_PROGRESS
                    }
                }
            }
            const { report, matrix, sources } = this.fetchReportMatrixSources(data.kpiData as string ?? '');
            if (this.kpiResult[data.kpiId as string]) {
                this.kpiResult[data.kpiId as string] = {
                    ...this.kpiResult[data.kpiId as string],
                    kpiData: {
                        ...this.kpiResult[data.kpiId as string]?.kpiData,
                        final_response: data.kpiData as string ?? '',
                        report: report as string ?? '',
                        matrix: matrix,
                        sources: sources as any
                    },
                    kpiStatus: data.kpiStatus as COMPARE_DOCUMENT_STATUS
                };
            }

        }
        if (data.event === COMPARE_SOCKETS_EVENTS.COMPARE_KPI_MESSAGES) {
            // this.kpiResult.kpis[data.kpiId] = data.kpiMessages;
        }
        if (data.event === COMPARE_SOCKETS_EVENTS.COMPARE_KPI_TODOS) {
            // this.kpiResult.kpis[data.kpiId] = data.kpiTodos;
        }

    }

    areSetsEqual(set1: Set<string>, set2: Set<string>): boolean {
        if (set1.size !== set2.size) return false;
        for (const item of set1) {
            if (!set2.has(item)) return false;
        }
        return true;
    }
    // #endregion

    // #region Fullscreen Dialog Management
    openFullscreenDialog(type: FullscreenDialogType, kpi: { key: string, value: ICompareKpi }): void {
        if (!kpi) {
            return;
        }
        this.currentKpiForDialog = kpi;

        // Configure dialog based on type
        switch (type) {
            case FullscreenDialogType.COMPLIANCE_MATRIX:
                this.fullscreenDialog = {
                    visible: true,
                    type: FullscreenDialogType.COMPLIANCE_MATRIX,
                    title: 'Compliance Matrix - ' + kpi.value.kpiDoc.name,
                    class: 'compliance-matrix-dialog',
                    size: { width: '60vw', height: '60vh' }
                };
                break;
            case FullscreenDialogType.CHART:
                this.fullscreenDialog = {
                    visible: true,
                    type: FullscreenDialogType.CHART,
                    title: 'Chart - ' + kpi.value.kpiDoc.name,
                    class: 'chart-dialog',
                    size: { width: '60vw', height: '60vh' }
                };
                break;
            case FullscreenDialogType.FULL_REPORT:
                this.fullscreenDialog = {
                    visible: true,
                    type: FullscreenDialogType.FULL_REPORT,
                    title: 'Full Report - ' + kpi.value.kpiDoc.name,
                    class: 'full-report-dialog',
                    size: { width: '80vw', height: '80vh' }
                };
                break;
        }
    }

    openComplianceMatrixFullscreen(event: Event, kpi: any): void {
        event.stopPropagation();
        event.preventDefault();
        this.openFullscreenDialog(FullscreenDialogType.COMPLIANCE_MATRIX, kpi);
    }

    openChartFullscreen(event: Event, kpi: any): void {
        event.stopPropagation();
        event.preventDefault();
        this.openFullscreenDialog(FullscreenDialogType.CHART, kpi);
    }

    openFullReportFullscreen(event: Event, kpi: any): void {
        event.stopPropagation();
        event.preventDefault();
        this.openFullscreenDialog(FullscreenDialogType.FULL_REPORT, kpi);
    }

    closeFullscreenDialog(): void {
        this.fullscreenDialog.visible = false;
        this.currentKpiForDialog = null;
    }
    // #endregion

    // #region Panel Management
    toggleRightPanel(): void {
        if (!this.rightPanelCollapsed) {
            this.rightPanelSize = this.currentPanelSizes[1];
            const spaceToDistribute = this.currentPanelSizes[1] - 3;
            this.currentPanelSizes = [this.currentPanelSizes[0] + spaceToDistribute, 3];
        } else {
            const spaceToTake = this.rightPanelSize - 3;
            this.currentPanelSizes = [this.currentPanelSizes[0] - spaceToTake, this.rightPanelSize];
        }
        this.rightPanelCollapsed = !this.rightPanelCollapsed;
    }

    getPanelSizes(): number[] {
        return this.currentPanelSizes;
    }

    getMinSizes(): number[] {
        const collapsedMinSize = 3;
        return [20, this.rightPanelCollapsed ? collapsedMinSize : 5];
    }

    onResizeStart(event: any): void {
        if (event && event.sizes) {
            this.resizeStartSizes = [...event.sizes];
        } else {
            this.resizeStartSizes = [...this.currentPanelSizes];
        }
        this.isRightGutterResizing = true;
    }

    onPanelResizing(event: any): void {
        if (event && event.sizes && !this.rightPanelCollapsed) {
            this.currentPanelSizes = [...event.sizes];
        }
    }

    onPanelResize(event: any): void {
        if (event && event.sizes && !this.rightPanelCollapsed) {
            this.currentPanelSizes = [...event.sizes];
            this.lastPanelSizes = [...event.sizes];
            this.rightPanelSize = event.sizes[1];
        }
        this.isRightGutterResizing = false;
    }

    initializePanelSizes(): void {
        if (this.currentPanelSizes[0] === 70 && this.currentPanelSizes[1] === 30) {
            this.lastPanelSizes = [...this.currentPanelSizes];
            this.rightPanelSize = this.currentPanelSizes[1];
        }
    }

    getRightButtonPosition(): number {
        if (this.rightPanelCollapsed) {
            return 97;
        }
        return this.currentPanelSizes[0];
    }
    // #endregion

    // #region Tour/Walkthrough Methods
    resetWalkthrough() {
        this.initializeTour();
    }

    initializeTour() {
        this.currentStepNumber = 0;
        let elementsToWait: string[] = ['[step-id="compare-step1"]', '[step-id="compare-step6"]', '[step-id="compare-step7"]'];

        Promise.all(elementsToWait.map(selector => this.waitForElement(selector)))
            .then(() => {
                this.driver = driver({
                    stageRadius: 14,
                    showProgress: true,
                    nextBtnText: 'Next',
                    allowClose: true,
                    prevBtnText: 'Previous',
                    onCloseClick: () => this.completeTour(),
                    onDestroyed: () => this.completeTour(),
                    popoverClass: 'custom-popover',
                    showButtons: ['next', 'previous'],
                    steps: [
                        { element: '[step-id="compare-step1"]', popover: { title: 'Add more documents to compare', description: 'Expand your analysis by adding more documents to the comparison. Select from existing files, repository and also previous versions to ensure a comprehensive review.', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step2"]', popover: { title: 'Compare AI Chatbot', description: 'Engage in a dynamic conversation with InnDoc AI to explore insights across all compared documents. Ask questions, uncover key details, and gain a deeper understanding.', side: "left" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step3"]', popover: { title: 'Key Performance Indicators', description: 'Stay ahead with data-driven insights! KPIs highlight critical metrics tailored to your document type, helping you assess key aspects at a glance.', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step4"]', popover: { title: 'Add KPI', description: 'Shape your analysis the way you need! Define Custom KPIs to focus on the metrics that matter most to your project, ensuring your comparisons align with specific priorities and requirements.', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step5"]', popover: { title: 'History', description: 'Need to revisit a previous comparison ? Easily access past comparisons for reference', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step6"]', popover: { title: 'Export', description: 'Get a comprehensive comparison report, outlining key insights for thorough analysis and informed decision-making', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step7"]', popover: { title: 'Document', description: 'Preview all documents included in the comparison', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step8"]', popover: { title: 'Reports', description: 'View and download detailed reports on comparison', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step9"]', popover: { title: 'Audit Logs', description: 'Track all user actions and changes across the comparison for transparency and accountability', side: "bottom" as const, align: 'start' as const } },
                        { element: '[step-id="compare-step10"]', popover: { title: 'Comments', description: 'Collaborate in real-time by adding feedback, suggestions, and discussions', side: "bottom" as const, align: 'start' as const } },
                    ],
                });

                const element = document.querySelector('[step-id="compare-step1"]');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                setTimeout(() => this.driver?.drive(), 300);
            });
    }

    completeTour() {
        this.currentStepNumber = 0;
    }

    waitForElement(selector: string, timeout = 5000): Promise<void> {
        return new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                if (document.querySelector(selector)) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
            setTimeout(() => {
                clearInterval(interval);
                reject(new Error(`Element not found: ${selector}`));
            }, timeout);
        });
    }

    // #region Support Dialog Methods
    openHelp(): void {
        this.supportTicketDialog = true;
    }

    openCapture(): void {
        this.captureIssueComponent.openCaptureDialog();
    }

    onCaptureCompleted(result: CaptureResult): void {
        this.supportTicketDialog = true;
        setTimeout(() => {
            if (this.supportTicketFormComponent) {
                this.supportTicketFormComponent.attachmentFiles.push(result.file);
                this.supportTicketFormComponent.attachmentPreviews.push(result);
            }
        }, 0);
    }

    onSupportTicketSubmitted(): void {
        this.supportTicketDialog = false;
    }

    onSupportTicketDialogHide(): void {
        if (this.supportTicketFormComponent) {
            this.supportTicketFormComponent.resetForm();
        }
        this.supportTicketDialog = false;
    }
    // #endregion

}
